module.exports = __webpack_public_path__ + "img/h8.b6f27235.png";